import _ from 'underscore';
import { ColumnFormat, I18n } from '../well-known-type';

const { identity, compose } = _;

// exported from `@bingads-webui/projection-grid-base-column`
export function getFormatter(format: ColumnFormat, i18n: I18n, placeholder: string = '-') {
  let formatter: Function = identity;

  if (!format) {
    return formatter;
  }

  switch (format) {
    case ColumnFormat.Percentage:
      formatter = compose(
        i18n.percentFormatter(),
        Number
      );
      break;
    case ColumnFormat.PercentageValue:
      formatter = compose(
        i18n.percentToFixedFormatter({ digits: 2 }),
        (value: number) => value / 100,
        Number
      );
      break;
    case ColumnFormat.Integer:
      formatter = compose(
        i18n.decimalToIntegerFormatter(),
        Number
      );
      break;
    case ColumnFormat.Natural:
      formatter = (() => {
        const fmt = compose(
          i18n.decimalToIntegerFormatter(),
          Number
        );
        return (value: number) => (Number.isFinite(value) && value >= 1 ? fmt(value) : placeholder);
      })();
      break;
    case ColumnFormat.Decimal:
      formatter = compose(
        i18n.decimalToFixedFormatter(),
        Number
      );
      break;
    case ColumnFormat.Thousandth:
      formatter = compose(
        i18n.decimalToFixedFormatter(),
        (value: number) => value / 1000,
        Number
      );
      break;
    default:
      break;
  }

  return (value: any) => (value === null
    || value === undefined
    || (Object.values(ColumnFormat).includes(format) && value === '') ?
    placeholder :
    formatter(value));
}
